import { FaPlus } from "react-icons/fa6";
import { FiMinus } from "react-icons/fi";
import React, { useState } from "react";
import { useMediaQuery } from "react-responsive";

const FAQData = [
  {
    questNo: 1,
    quest: "Do I need a developer to get started?",
    response:
      "No. Kwik Engage is built to be plug-and-play. You can launch campaigns and automations without any coding, and our team provides full onboarding support.",
  },
  {
    questNo: 2,
    quest: "Can I integrate Kwik Engage with my existing tools?",
    response:
      "Yes. Kwik Engage integrates with leading D2C platforms and apps (like Appbrew, Shopify, and more). Enterprise plans also support custom integrations.",
  },
  {
    questNo: 3,
    quest: "What kind of support will I get?",
    response:
      "All plans come with WhatsApp & email support. Pro and Enterprise customers get a dedicated Customer Success Manager (CSM) to guide setup, strategy, and growth.",
  },
  {
    questNo: 4,
    quest: "How is pricing calculated?",
    response:
      "Pricing is based on the plan you choose (Growth, Pro, or Enterprise). Growth starts as low as ₹3,800/month, and Enterprise plans are custom depending on your scale.",
  },
  {
    questNo: 5,
    quest: "How does Kwik Engage help me recover more carts?",
    response:
      "Our AI-powered calling and chat automatically follow up with shoppers who abandon their carts, nudging them to complete purchases. This drives higher recovery rates without adding manual effort.",
  },
  {
    questNo: 6,
    quest: "What makes Kwik Engage different from other tools?",
    response:
      "Unlike generic marketing platforms, Kwik Engage is purpose-built for D2C brands. With features like KwikPass (for identifying up to 25% more users), AI-powered retries (20% higher message delivery), and retention-focused automations, we deliver measurable revenue growth.",
  },
  {
    questNo: 7,
    quest: "Is there a free trial?",
    response:
      "Yes. We offer a 14-day free trial so you can experience the impact of Kwik Engage before committing.",
  },
  {
    questNo: 8,
    quest: "Can I change or upgrade my plan later?",
    response:
      "Absolutely. You can upgrade as your business grows, and all your data and automations carry over without disruption.",
  },
  {
    questNo: 9,
    quest: "How long does it take to see results?",
    response:
      "Most brands start seeing improvements in cart recovery and repeat purchases within the first 2–4 weeks of using Kwik Engage.",
  },
  {
    questNo: 10,
    quest: "Is Kwik Engage compliant with ISO data security certification?",
    response:
      "Yes. We adhere to strict data privacy and compliance standards, so your customer data is always safe and secure. We are PCI DSS and ISO certified.",
  },
];

const SectionFour = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [showAll, setShowAll] = useState(false);
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const toggleAccordion = (index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const visibleFAQs = showAll ? FAQData : FAQData.slice(0, 4);

  return (
    <div
      className="section-four-price-faq-ind"
      style={{ bottom: isMobile ? "120px" : "100px" }}
    >
      <div
        style={{
          minHeight: "70vh",
          padding: "0",
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            maxWidth: "700px",
            margin: isMobile ? "0 20px" : "80px auto",
          }}
        >
          <h1
            style={{
              textAlign: "center",
              color: "#000",
              fontSize: !isMobile ? "44px" : "24px",
              fontWeight: 700,
              marginBottom: "24px",
              // fontFamily: "Inter, Arial, sans-serif",
            }}
          >
            Frequently Asked Questions
          </h1>
          <p
            style={{
              textAlign: "center",
              color: "#000",
              fontSize: !isMobile ? "18px" : "14px",
              fontWeight: 400,
              // fontFamily: "Inter, Arial, sans-serif",
            }}
          >
            Have questions about Kwik Engage? We've got answers. Learn more
            about our platform's ease of use, integration capabilities, and
            dedicated support system.
          </p>

          <div>
            {visibleFAQs.map((faq, idx) => (
              <div
                key={faq.questNo}
                style={{
                  background: "#fff",
                  borderRadius: "7px",
                  boxShadow: "0 1px 2px 0 rgba(16,24,40,0.04)",
                  marginBottom: "16px",
                  overflow: "hidden",
                  border: "1px solid #eee",
                  marginTop: "15px",
                }}
              >
                <button
                  style={{
                    width: "100%",
                    background: "transparent",
                    border: "none",
                    outline: "none",
                    padding: 0,
                    cursor: "pointer",
                    textAlign: "left",
                  }}
                  onClick={() => toggleAccordion(idx)}
                  aria-expanded={activeIndex === idx}
                  aria-controls={`faq-response-${idx}`}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      fontSize: "1.1rem",
                      fontWeight: 500,
                      color: "#111",
                      padding: "18px 20px",
                      // fontFamily: "Inter, Arial, sans-serif",
                    }}
                  >
                    <span>{faq.quest}</span>
                    <span
                      style={{
                        marginLeft: "20px",
                        color: "#222",
                        fontSize: "19px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {activeIndex === idx ? <FiMinus /> : <FaPlus />}
                    </span>
                  </div>
                </button>
                <div
                  id={`faq-response-${idx}`}
                  style={{
                    maxHeight: !isMobile
                      ? activeIndex === idx
                        ? "200px"
                        : "0"
                      : activeIndex === idx
                      ? "220px"
                      : "0",
                    overflow: "hidden",
                    background: "#fff",
                    transition: "max-height 0.35s cubic-bezier(0.4, 0, 0.2, 1)",
                    padding:
                      activeIndex === idx ? "0 20px 16px 20px" : "0 20px",
                    opacity: activeIndex === idx ? 1 : 0,
                    fontSize: "1.05rem",
                    color: "#333",
                  }}
                >
                  {activeIndex === idx && (
                    <div style={{ paddingTop: "4px", paddingBottom: "2px" }}>
                      {faq.response}
                    </div>
                  )}
                </div>
              </div>
            ))}

            {FAQData.length > 4 && (
              <div style={{ textAlign: "center", marginTop: "20px" }}>
                <button
                  onClick={() => setShowAll(!showAll)}
                  className="start-now-btn"
                  style={{minWidth:"150px",margin:"0"}}
                >
                  {showAll ? "See Less" : "See More"}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionFour;
